//**auto-generated don't edit this code**//
export enum PeriodType {
	None,
	Manual,
	Today,
	ThisWeek,
	ThisMonth,
	CurrentMarkingPeriod,
	CurrentSchoolYear,
	Yesterday,
	PreviousWeek,
	PreviousMonth,
	PreviousMarkingPeriod,
	PreviousSelectedMarkingPeriod,
}